<div class="verification-dialog">
  <p>{{ 'security_verification.description' | transloco }}</p>

  <nz-radio-group [ngModel]="method()" (ngModelChange)="method.set($event)">
    <label nz-radio nzValue="email_otp">{{ 'security_verification.methods.email' | transloco }}</label>
    <label nz-radio nzValue="mfa" [nzDisabled]="factors().length === 0">MFA</label>
  </nz-radio-group>

  <div class="verification-fields">
    @switch (method()) {
      @case ('email_otp') {
        <div class="email-row">
          <input nz-input [value]="email()" disabled />
          <button
            nz-button
            [nzLoading]="emailSending()"
            [disabled]="emailCooldown() > 0"
            (click)="sendEmailCode()"
          >
            @if (emailCooldown() > 0) {
              {{
                'security_verification.send_code_countdown'
                  | transloco: {seconds: emailCooldown()}
              }}
            } @else {
              {{ 'security_verification.send_code' | transloco }}
            }
          </button>
        </div>
        <input nz-input maxlength="6" [placeholder]="'security_verification.email_code_placeholder' | transloco"
          [ngModel]="emailCode()" (ngModelChange)="emailCode.set($event)" />
      }
      @case ('mfa') {
        <nz-select [ngModel]="selectedFactorId()" (ngModelChange)="selectedFactorId.set($event)">
          @for (factor of factors(); track factor.id) {
            <nz-option [nzValue]="factor.id" [nzLabel]="factor.friendly_name || 'Authenticator'"></nz-option>
          }
        </nz-select>
        <input nz-input maxlength="6" [placeholder]="'security_verification.mfa_code_placeholder' | transloco"
          [ngModel]="mfaCode()" (ngModelChange)="mfaCode.set($event)" />
      }
    }
  </div>

  @if (error()) {
    <nz-alert nzType="error" nzShowIcon [nzMessage]="error()"></nz-alert>
  }

  <div class="verification-actions">
    <button nz-button (click)="modalRef.close()">{{ 'security_verification.cancel' | transloco }}</button>
    <button nz-button nzType="primary" [nzLoading]="loading()" (click)="verify()"
      [disabled]="method() === 'email_otp' && emailCode().length !== 6">
      {{ 'security_verification.continue' | transloco }}
    </button>
  </div>
</div>
